import type { PropsWithChildren } from "react";
import React from "react";
import "@repo/ui/styles.css";
import { Footer } from "@repo/ui/footer";
import { useLocale } from "next-intl";
import { getLangDir } from "rtl-detect";
import { Toaster } from "@repo/ui/toaster";
import Image from "next/image";
import bgShadowRight from "@/public/images/bg-shadow-right.png";
import bgShadowLeft from "@/public/images/bg-shadow-left.png";

export function Default({ children }: PropsWithChildren): React.JSX.Element {
  const locale = useLocale();
  const direction = getLangDir(locale);

  return (
    <div className=" web-relative" dir={direction} lang={locale}>
      <div className="web-absolute web-right-0 web-top-[15%]">
        <Image alt="bg-shadow-right" src={bgShadowRight} />
      </div>
      <div className="web-absolute web-right-0 web-top-[60%]">
        <Image alt="bg-shadow-right" src={bgShadowRight} />
      </div>
      <div className="web-absolute web-left-0 web-top-[35%]">
        <Image alt="bg-shadow-left" src={bgShadowLeft} />
      </div>
      {children}
      <Footer
        description={
          locale === "fa"
            ? "سفر خود را در یک دقیقه رزرو کنید، کنترل کامل را برای مدت طولانی تری دریافت کنید."
            : "Book your trip in minute, get full Control for much longer."
        }
        title={locale === "fa" ? "خزر ترانسفو" : "KHAZAR TRANSFO"}
      />
      <Toaster />
    </div>
  );
}
